import(/* webpackMode: "eager" */ "/vercel/path0/app/(footer)/blog/[post]/post.tsx")